export type SummeryItem = {
  [name: string]: {
    max: number
    avg: number
    sum: number
    maxTime: string
    min: number
    minTime: string
    last?: { [index: number]: number }
  }
}

export type SummaryItemKey = 'max' | 'avg' | 'sum' | 'maxTime' | 'last'

export default class Summery {
  public stationId: string
  public items: SummeryItem

  constructor({ stationId, items }: { stationId: string; items: SummeryItem }) {
    this.stationId = stationId
    this.items = items
  }
}
